/** Resolve a public static asset against Vite's configured asset base/CDN URL. */
export function assetUrl(path: string): string {
	return `${import.meta.env.BASE_URL}${path.replace(/^\/+/, "")}`;
}
